// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "../Spinner", "."], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("../Spinner"), require("."));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.Spinner, global._);
    global.LoadingButton = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _Spinner, _) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.LoadingButton = _exports.Loading = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  var LoadingButton = _exports.LoadingButton = function LoadingButton(props) {
    var loading = props.loading,
      disabled = props.disabled,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: [loading && !disabled ? 'cop-relative cop-inline-block cop-items-center cop-rounded cop-bg-[#212B36] cop-text-white cop-transition-opacity' : '', className].join(' ')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "cop-absolute cop-flex cop-h-full cop-w-full cop-items-center cop-justify-center ".concat(loading && !disabled ? 'cop-visible' : 'cop-invisible')
    }, /*#__PURE__*/_react["default"].createElement(_Spinner.Spinner, {
      size: 5
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(loading && !disabled ? 'cop-invisible' : 'cop-visible')
    }, /*#__PURE__*/_react["default"].createElement(_.Button, props)));
  };
  var Loading = _exports.Loading = function Loading(props) {
    return /*#__PURE__*/_react["default"].createElement(LoadingButton, props);
  };
});
